// extracted by mini-css-extract-plugin
export var box = "_4r-1";
export var checked = "_4r-2";
export var descriptionSpacer = "_4r-9";
export var disabled = "_4r-3";
export var icon = "_4r-6";
export var input = "_4r-0";
export var labelSpacer = "_4r-8";
export var medium = "_4r-5";
export var small = "_4r-4";
export var text = "_4r-7";